<template>
	<base-drawer>
		<w-flex column>
			<header style="margin-top: 42px;">
				<w-flex class="wrap no-grow text-left">
					<div class="xs6 md6 lg4 xl6 pa1">
						<div class="">
							<w-select
								v-model="selectedShekh"
								:items="shekhList"
								outline="outline"
								>Choose Shekh</w-select
							>
						</div>
					</div>
				</w-flex>
			</header>
			<main class="grow">
				<w-flex wrap class="ml4">
					<div class="xs12 md12 lg12 xl12">
						<w-card
							shadow
							class="xs12 md12 lg12 xl12 primary--bg white mb4 pl3 titleCard"
						>
							Khutba List
							<div
								v-if="addTitleVisible"
								class="setting bg-main white add"
								@click="addKhutba('new')"
							>
								<i class="mdi mdi-plus"></i>
							</div>
						</w-card>
						<div v-if="!isLoading">
							<w-flex wrap class="mt0">
								<div
									class="title-container"
									style="width: 100%;"
								>
									<div
										style="display: none;padding: 0px;margin: 0px;width: 100%;"
										class="audioError"
									>
										<w-alert
											error
											icon-outside
											color="error"
											style="margin: 10px;"
											><div>Error</div></w-alert
										>
									</div>
									<section>
										<w-flex wrap class="play-list">
											<div
												class="lg12 md12 sm12 xs12"
												v-for="(audio,
												index) in khutbaList"
												:key="audio.khutba_id"
											>
												<card-content
													class="play-list-row titleCard"
													:data-track-row="
														generateIndex(index)
													"
												>
													<div
														class="small-toggle-btn" :class="{'active':index==activeIndex && activeKey && activeId==audio.khutba_id}"
													>
														<i
															class="small-play-btn" :class="{'small-pause-btn':index==activeIndex && activeKey && activeId==audio.khutba_id}"
															><span
																class="screen-reader-text"
																>Small toggle
																button</span
															></i
														>
													</div>
													<div
														class="track-number"
													></div>
													<div
														class="track-title text-uppercase"
													>
														<a
															class="playlist-track"
															href="#"
															:data-play-track="
																generateIndex(
																	index
																)
															"
															@click="playNow(index)"
														>
															{{
																audio.khutba_title
															}}</a
														>
														<span
															class="fa fa-bullseye scale_motion" :class="{'activeDot': index==activeIndex && activeKey && activeId==audio.khutba_id}"
														></span>
														<div
															title="Edit"
															class="setting info-dark2--bg white edit"
															@click="addKhutba('old',audio)
															"
														>
															<i
																class="mdi mdi-pencil"
															></i>
														</div>
														<div
															title="delete"
															class="setting error--bg white delete"
															@click="
																deleteKhutba(
																	audio.khutba_id
																)
															"
														>
															<i
																class="mdi mdi-delete"
															></i>
														</div>
													</div>
													<!-- <div
																class="btnDownload"
																@click="
																	downloadAudio(
																		audio.filename,
																		audio.resource_name
																	)
																"
															>
																<i
																	class="fa fa-download"
																></i>
															</div> -->
												</card-content>
											</div>
										</w-flex>
									</section>
								
								</div>

								<div
									class="text-center"
									v-if="noresult.audios"
									style="margin: 0 auto"
								>
									<img
										src="../assets/noresult.png"
										class="noresult"
										alt=""
									/>
								</div>
								<div
									class="text-center"
									v-if="isLoading.audios"
									style="margin: 0 auto"
								>
									<img
										src="../assets/loader.gif"
										class="loader"
										alt=""
									/>
								</div>
							</w-flex>
						</div>
						<div class="text-center" v-if="noresult">
							<img
								src="../assets/noresult.png"
								class="noresult"
								alt=""
							/>
						</div>
						<div class="text-center" v-if="isLoading">
							<img
								src="../assets/loader.gif"
								class="loader"
								alt=""
							/>
						</div>
					</div>
				</w-flex>

				<w-dialog
					v-model="dialog.showForm"
					:fullscreen="true"
					:width="1000"
					:persistent="false"
					title-class="bg-main white"
					transition="bounce"
				>
					<template #title="">
						<w-icon class="mr2">mdi mdi-plus</w-icon>{{btnAddAudio}} Khutba
					</template>

					<div class="xs12 md12 lg12 xl12 primary pa1">
						<w-flex wrap class="mt2 justify-center mt10">
							<div
								class="xs12 md6 lg4 xl12 primary pa2 titleCard"
							>
								<w-card shadow class="m2" bg-color="white">
									<w-alert success v-if="audioSuccess"
										>Khutba {{btnAddAudio}} Successful</w-alert
									>
									<w-alert error v-if="audioError" dismiss
										>Fail To {{btnAddAudio}} Khutba, Please Try
										Again</w-alert
									>
									<w-form
										action="#"
										method="post"
										@submit.prevent="sendKhutba()"
										style="margin: 0 auto;"
									>
										<w-input
											v-model="audioTitle"
											type="text"
											label="Audio Title"
											outline="outline"
											class="mb4"
											:validators="[validators.required]"
										/>
										<input
											type="file"
											outline="outline"
											class="mb4"
											id="file"
											ref="file"
											required="true"
											v-on:change="handleFileUpload()"
										/>
										<w-textarea
											no-autogrow="no-autogrow"
											v-model="khutbaDesc"
											rows="6"
											:validators="[validators.required]"
											>Description</w-textarea
										>
										<w-button
											class="ma1"
											type="submit"
											bg-color="primary"
											:loading="button1loading"
										>
											<w-icon class="mr1">wi-check</w-icon
											>{{ btnAddAudio }}
										</w-button>
									</w-form>
								</w-card>
							</div>
						</w-flex>
					</div>

					<template #actions="">
						<div class="spacer"></div>
						<w-button @click="dialog.showForm = false"
							>Close</w-button
						>
					</template>
				</w-dialog>
			</main>
		</w-flex>
	</base-drawer>
</template>
<script>
import axios from 'axios';

export default {
	data: () => ({
		showPlayer: false,
		loadScript: 0,
		showDrawer: false,
		addTitleVisible: false,
		selectedShekh: [],
		shekhList: [],
		khutbaList: [],
		audioTitle: '',
		khutbaId: null,
		khutbaDesc: '',
		file: undefined,
		showAudioForm: false,
		button1loading: false,
		btnAddAudio: 'SAVE',
		audioSuccess: false,
		audioError: false,
		dialog: { width: 500, show: false, showForm: false },
		validators: {
			required: (value) => !!value || 'This field is required',
		},
		statusCode: '',
		noresult: false,
		isLoading: false,
	}),
	methods: {
		playNow(i) {
			let s = this.selectedShekh;

			this.$store.state.playlist = this.khutbaList;
			this.$store.state.playlist.map((x)=>{
				x.filename = x.khutba_file;
				x.resource_name = x.khutba_title;
				return x;
			});
			this.$store.state.player.key = 'khutba';
			this.$store.state.player.active = i;
			this.$store.state.player.audioClicked +=1;
			this.$store.state.player.path="khutba/"+s+'/';
			
			this.$store.state.player.showPlayer = true;
		},
		generateIndex(index) {
			return ++index;
		},
		getShekh() {
			axios
				.get('shekh.php?status=all')
				.then((data) => {
					var res = data.data;
					if (res.status == 200) {
						for (var i = 0; i < res.data.length; i++) {
							let sh = res.data[i];
							this.shekhList.push({
								label: sh.shekh_name,
								value: sh.shekh_id,
							});
						}
					}
				})
				.catch((error) => {
					alert(error);
				});
		},
		getKhutba(shekh) {
			this.isLoading = true;
			this.noresult = false;
			axios
				.get('khutba.php?status=khutbaByShekh&id=' + shekh)
				.then((data) => {
					let result = data.data;
					var code = result.status;
					this.isLoading = false;
					if (result.data && code == 200) {
						this.khutbaList = result.data;
					} else {
						this.khutbaList = [];
					}
				})
				.catch(() => {
					this.isLoading = false;
					this.khutbaList = [];
				});
		},
		addKhutba(status,audio={}) {
			// alert(JSON.stringify(audio))
			this.btnAddAudio = status=='new'?'SAVE':"UPDATE";
			this.titleStatus = status;
			this.audioTitle = audio.khutba_title??'';
			this.khutbaId = audio.khutba_id??'';
			this.khutbaDesc = audio.khutba_desc??'';

			this.audioSuccess = false;
			this.audioError = false;
			this.dialog.showForm = true;
		},
		sendKhutba() {
			if (
				this.audioTitle != '' &&
				this.khutbaDesc != ''
			) {
				this[`button1loading`] = true;
				var formData = new FormData();
				formData.append('titleName', this.audioTitle);
				if (this.btnAddAudio == 'SAVE') {
					formData.append('status', 'new');
					formData.append('title', this.audioTitle);
					formData.append('audio', this.file);
					formData.append('desc', this.khutbaDesc);
					formData.append('shekhId', this.selectedShekh);
					formData.append('userId', 7);
				} else if (this.btnAddAudio == 'UPDATE') {
					formData.append('status', 'old');
					formData.append('title', this.audioTitle);
					formData.append('khutbaId', this.khutbaId);
					formData.append('desc', this.khutbaDesc);
				}
				axios
					.post('khutba.php', formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					})
					.then((data) => {
						this[`button1loading`] = false;
						let resp = data.data;
						// alert(JSON.stringify(resp))
						if (resp.status == 200) {
							this.getKhutba(this.selectedShekh);
							this.audioSuccess = true;
							this.audioError = false;
						} else {
							this.audioError = true;
						}
					})
					.catch(() => {
						this[`button1loading`] = false;
						this.audioError = true;
					});
			} else {
				this.audioError = true;
			}
		},
		deleteKhutba(id) {
			let conf = confirm('Khutba Will Be Deleted !!!');
			if (conf) {
				axios
					.post(
						'khutba.php',
						JSON.stringify({
							status: 'block',
							khutba_id: id,
						})
					)
					.then((data) => {
						let res = data.data;
						if (res.status == 200) {
							this.getKhutba(this.selectedShekh);
							alert('Khutba Deleted Successfull!!!');
						} else {
							alert(
								'Fail To Delete Khutba, Please Try Again Letter !!!'
							);
						}
					})
					.catch(() => {
						alert(
							'Fail To Delete Khutba, Please Try Again letter!!!'
						);
					});
			}
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},
		processor() {
			if (this.selectedShekh != '') {
				this.addTitleVisible = true;
				this.getKhutba(this.selectedShekh);
			} else {
				this.addTitleVisible = false;
			}
		},
	},
	computed:{
		activeIndex(){
			return this.$store.state.player.active;
		},
		activeKey(){
			return this.$store.state.player.key=='khutba';
		},
		activeId(){
			let i = this.$store.state.player.active;
			let id = this.$store.state.playlist[i].khutba_id??0;
			return id;
		}
	},
	watch: {
		selectedShekh() {
			this.processor();
		},
		khutbaList() {
			this.noresult =
				this.khutbaList == null || this.khutbaList.length == 0;
			this.loadScript += 1;
		},
	},
	mounted() {
		this.getShekh();
	},
};
</script>
<style scoped></style>
